import { useState } from "react";
import { flashItems } from "@/mocks/home";

export default function FlashFeed() {
  const [tab, setTab] = useState("全部");

  const sections = ["全部", "主播红人", "艺人圈", "游戏电竞", "品牌翻车", "饭圈塌房", "探店测评"];

  const list = tab === "全部" ? flashItems : flashItems.filter((f) => f.tag === tab);

  return (
    <section id="flash" className="border-t border-background-200 bg-background-50 py-10 md:py-14">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 md:px-6">
        {/* 分区头 */}
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <h3 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">快讯流</h3>
            </div>
            <p className="mt-2 text-sm text-foreground-500">
              滚动中的最新爆料与围观现场，按热度实时排序。带 <strong className="text-primary-600">红标</strong> 为高热度入档事件。
            </p>
          </div>

          <div className="flex w-fit flex-wrap items-center gap-1 rounded-full bg-secondary-100 p-1">
            {sections.map((s) => (
              <button
                key={s}
                type="button"
                onClick={() => setTab(s)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  tab === s ? "bg-background-50 text-foreground-950 shadow-none" : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {s}
              </button>
            ))}
          </div>
        </div>

        {/* 快讯卡片 */}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((f) => (
            <article key={f.id} className="group flex flex-col overflow-hidden rounded-lg bg-background-100">
              <div className="relative overflow-hidden">
                <img
                  src={f.cover}
                  alt={`98黑料 快讯：${f.title}`}
                  title={`98黑料 快讯流 ${f.tag} ${f.title}`}
                  className="aspect-[4/3] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-xs text-foreground-800 backdrop-blur">
                  <i className={`ri-flashlight-fill ${f.heat >= 85 ? "text-primary-500" : "text-accent-500"}`} />
                  {f.tag}
                </span>
                <span className="absolute bottom-3 right-3 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs text-background-100">
                  {f.time}
                </span>
              </div>
              <div className="flex flex-col p-4">
                <h4 className="line-clamp-2 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                  {f.title}
                </h4>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{f.excerpt}</p>
                <div className="mt-3 flex items-center gap-4 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500" />
                    热度 {f.heat}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line" />
                    {f.comments} 讨论
                  </span>
                  <span className="ml-auto flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}